import { DialogType } from '@/constants/constants';
import i18n from '@/i18n';
import { filterRulesMapped } from '@/tools/filterRules';
import { mapActions } from 'vuex';
import forwardService from '../../services/forward.service';
import { FORWARD_HEADERS } from './constants';
import ForwardDialogComponent from './createEdit/ForwardDialogComponent.vue';

export default {
    name: "ForwardComponent",
    components: {
        ForwardDialogComponent
    },
    data() {
        return {
            tableDataKey: "forward",
            tableHeaders: FORWARD_HEADERS,
            tableFilterRules: {},
            tableData: [],
            loading: false,
            tableActions: [],
            showCreateEditDialog: false,
            rowActions: [
                {
                    action: "edit",
                    name: i18n.t('modify'),
                    color: 'blue',
                    icon: 'fa-pen'
                },
                {
                    action: "delete",
                    name: i18n.t('delete'),
                    color: 'red',
                    icon: 'fa-trash-alt'
                }
            ],
            createEditModel: forwardService.getDefaultModel()
        };
    },
    async mounted() {
        this.tableActions.push(
            {
                id: 'create',
                tooltip: i18n.t('add'),
                icon: 'add',
                action: this.create.bind(this),
                selectedData: false
            }
        );
        this.loading = true;
        try {
            this.updateTable();
            this.setTableFilterRules();
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        async createEditForwarding() {
            try {
                if (this.createEditModel.edit) {
                    await forwardService.update(this.createEditModel);
                } else {
                    await forwardService.create(this.createEditModel);
                }
                this.showCreateEditDialog = false;
                await this.updateTable();
            } catch (e) {
                console.log(e);
            }
        },
        closeDialog() {
            this.showCreateEditDialog = false;
        },
        async rowButtonClicked(event, data) {
            if (event.action === 'delete') {
                this.deleteDialog(data);
            }
            if (event.action === 'edit') {
                await this.edit(data);
            }
        },
        async delete(data) {
            this.loading = true;
            try {
                await forwardService.detele(data.unitId);
                await this.refreshTable();
            } finally {
                this.loading = false;
            }
        },
        async edit(data) {
            this.createEditModel = forwardService.getDefaultModel(data);
            console.log(this.createEditModel)
            this.showCreateEditDialog = true;
        },
        async create() {
            this.createEditModel = forwardService.getDefaultModel();
            this.showCreateEditDialog = true;
        },
        async deleteDialog(data) {
            this.openDialog({
                title: this.$t('delete'),
                text: this.$t('forward.dialog.delete.message', { unitId: data.unitId }),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: () => {
                    this.delete(data)
                },
                noAction: () => {
                }
            })
        },
        async refreshTable() {
            try {
                this.loading = true;
                await this.updateTable();
            } finally {
                this.loading = false;
            }
        },
        async updateTable() {
            const forwards = await forwardService.getAll();
            const result = [];
            if (forwards && forwards.length > 0) {
                for (const forward of forwards) {
                    let urlsString = "";
                    for (const url of forward.urls) {
                        urlsString += url + "\n";
                    }
                    result.push({ urlsString, ...forward });
                }
            }
            this.tableData.cleanAndUpdate(result);
        },
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
    }
};
